import React from "react";
import AdminNavbar from "../Layout/AdminNavbar";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import ManagerNavbar from "../Layout/ManagerNavbar";

const resolveActiveRole = () => {
  const activeRole = localStorage.getItem("activeRole");
  const roles = JSON.parse(localStorage.getItem("roles") || "[]");

  if (activeRole === "ROLE_ADMIN") return "ROLE_ADMIN";
  if (activeRole === "ROLE_MANAGER") return "ROLE_MANAGER";
  if (activeRole === "ROLE_USER") return "ROLE_USER";

  if (roles.includes("ROLE_ADMIN")) return "ROLE_ADMIN";
  if (roles.includes("ROLE_MANAGER")) return "ROLE_MANAGER";
  return "ROLE_USER";
};

export default function AssetModuleNavbar() {
  const activeRole = resolveActiveRole();

  if (activeRole === "ROLE_ADMIN") return <AdminNavbar />;
  if (activeRole === "ROLE_MANAGER") return <ManagerNavbar />;
  return <EmployeeNavbar />;
}
